// © 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
/** Logical cell rectangles shared by rendering, hover, arming and physical selection. */
export const COMPACT_MENU = { width: .456, height: .114, canvasWidth: 1024, canvasHeight: 256,
  feedbackWidth: .170,feedbackHeight: .0128,totalHeight: .114 } as const
export interface MenuCell { x:number; y:number; width:number; height:number }
export function menuLayout(compact:boolean,count:number,trailingNavigation=false) {
  const width=compact?1024:512,height=compact?256:512
  const columns=compact?(count>8?3:2):1,rows=Math.max(compact&&trailingNavigation?2:1,Math.ceil(count/columns))
  const top=compact?32:50,bottom=compact?238:478,band=(bottom-top)/rows
  const column=width/columns
  const row=(index:number)=>compact&&trailingNavigation&&index>=count-2?rows-(count-index):compact?index%rows:index
  const cell=(index:number):MenuCell=>({x:compact?(trailingNavigation&&index>=count-2?columns-1:Math.floor(index/rows))*column+8:16,
    y:top+band*row(index)+(compact?1:3),
    width:column-(compact?16:32),height:band-(compact?2:6)})
  const at=(localX:number,localY:number):number=>{
    if(Math.abs(localX)>.11||Math.abs(localY)>.11||count<=0)return -1
    const x=(localX/.22+.5)*width,y=(.5-localY/.22)*height
    if(!compact)return Math.max(0,Math.min(count-1,Math.floor((y-top)/band)))
    for(let i=0;i<count;i++){const c=cell(i);if(x>=c.x&&x<=c.x+c.width&&y>=c.y&&y<=c.y+c.height)return i}
    return -1
  }
  return {width,height,columns,rows,cell,at}
}
